import { useState, useEffect } from "react";
import HeaderBar from "../HeaderBar";
import { unauthenticatedApi } from "../../Api";
import useStateMachineWrapper from "../../helpers/useStateMachineWrapper";

const AddressAvailable = (props) => {
    const {actions, state, sendState} = useStateMachineWrapper();

    const [isLoading, setIsLoading] = useState(false);
    const [isValidResponse, setIsValidResponse] = useState(true);

    // use this to get the current promos, pricing, etc.
    useEffect(() => {
      setIsLoading(true);

      unauthenticatedApi.get(`?endpoint=get-available-services&zip=${state.session.currentAddress.fill_zip}&market-id=${state.session.currentAddress.market_id}&sector=${state.session.currentAddress.sector}`)
            .then(response => {
                if(response.status != 200) {
                    setIsValidResponse(false);
                }
                actions.update({availableServices: response.data});
                setIsLoading(false);
            });
    }, []);

    return (<>
        <HeaderBar>
            <h1 className="bigger">Great News!</h1>
            <p>i3 Fiber is available!</p>
        </HeaderBar>
        <HeaderBar backPage={'intro'} nextPage={'choose-internet'} nextPageEnabled={isValidResponse} nextPageLoading={isLoading} className="mt-2 items-center">
            {isValidResponse === true && (<h1 className="bigger">Now let's get you the speed you need.</h1>)}
            {isValidResponse !== true && (<h1 className="bigger">Error - we were unable to find anything for your address. Please contact us if this error continues.</h1>)}
        </HeaderBar>
    </>)
};

export default AddressAvailable;